import { useQuery, type UseQueryOptions } from '@tanstack/react-query'
import { ownerApi, type OwnerWithCertificates } from 'services/ownerApi'
import { ownerQueryKeys } from './ownerQueryKeys'

type UseOwnerQueryOptions = Omit<UseQueryOptions<OwnerWithCertificates>, 'queryKey' | 'queryFn'>

export interface UseOwnerQueryParams {
  ownerId: string
  limit?: number
  offset?: number
}

export const useOwnerQuery = (
  params: UseOwnerQueryParams,
  options?: UseOwnerQueryOptions
) => {
  const { ownerId, limit, offset } = params

  const query = useQuery({
    queryKey: ownerQueryKeys.detail(ownerId, { limit, offset }),
    queryFn: () => ownerApi.getOwnerById(ownerId, { limit, offset }),
    enabled: Boolean(ownerId),
    staleTime: 1000 * 60 * 5, // 5 minutes
    ...options,
  })

  return {
    data: query.data || null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
    isFetching: query.isFetching,
  }
}
